import React from "react";
import { Badge } from "./Badge";

/**
 * Accepted by a research run itself (`--auto-accept` on the artist or event agent), not by a
 * person. A record whose every item was accepted that way resolves itself, so this badge — on the
 * Resolved tab as much as the open one — is how an item written with no one looking gets looked at.
 */
export const AutoAcceptedBadge = () => (
  <Badge variant="warning" title="Accepted automatically by the research run, not by an admin: check it">
    Auto-accepted
  </Badge>
);
